import React, { useEffect, useState } from "react";
import {
  Button,
  ButtonToolbar,
  Form,
  Loader,
  Container,
  Content,
  Checkbox,
  Modal,
} from "rsuite";
import { StoreServices } from "../../../core/services/StoreServices";
import { UtilityServices } from "../../../core/services/UtilityServices";
import "./Stores.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { displayField } from "../../../utils/helpers";
import { md } from "node-forge";

const ViewStoreModal = (props: any) => {
  const { t } = useTranslation();
  const storeViewId = useSelector((state: any) => {
    return state?.actionData?.id;
  });
  const [loader, setLoader] = useState(false);
  const [storeInfo, setStoreInfo] = useState<any>({});
  const [address, setAddress] = useState<any>({});
  async function getViewStoreDetail(id: number) {
    try {
      setLoader(true);
      const res = await StoreServices.viewStore(id);
      setLoader(false);
      if (res && res.data && res.data.data) {
        setStoreInfo({ ...res.data.data });
      }
    } catch (error) {
      setLoader(false);
    }
  }
  useEffect(() => {
    getViewStoreDetail(storeViewId);
  }, []);

  return (
    <div className="modal-container">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          content={t("LOADING")}
          center
          backdrop={true}
        />
      )}
      <Modal
        open={props.status}
        backdrop={false}
        onClose={(e: any) => {
          props.toggle("");
        }}
        size="md"
      >
        <Modal.Header>
          <h4 className="text-center">
            {t("VIEW")} {t("DETAIL")}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <div className="companies">
            <Container className="container">
              {storeInfo && Object.keys(storeInfo).length ? (
                <Content>
                  <Form layout="inline">
                    <Form.Group controlId="store_name">
                      <Form.ControlLabel>
                        {t("STORE")} {t("NAME")}:
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${storeInfo?.store_name}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="store_code">
                      <Form.ControlLabel>
                        {t("STORE")} {t("CODE")}:
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${storeInfo?.store_code}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="mobile">
                      <Form.ControlLabel>{t("MOBILE")}:</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${storeInfo?.mobile}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <h5 className="mt-3 mb-1">{t("ADDRESS")}</h5>
                    <Form.Group controlId="house_no">
                      <Form.ControlLabel>{t("HOUSE_NO")}:</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${storeInfo?.house_no}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="building">
                      <Form.ControlLabel>{t("BUILDING")}:</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${storeInfo?.building?.building_name}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="landmark">
                      <Form.ControlLabel>{t("LANDMARK")}:</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${storeInfo?.landmark}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="area">
                      <Form.ControlLabel>{t("AREA")}:</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${storeInfo?.area?.area_name}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="pincode">
                      <Form.ControlLabel>{t("PINCODE")}:</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${storeInfo?.pincode}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="city">
                      <Form.ControlLabel>{t("CITY")} :</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${storeInfo?.city?.city_name}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="state">
                      <Form.ControlLabel>{t("STATE")} :</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${storeInfo?.state?.state_name}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="country">
                      <Form.ControlLabel>{t("COUNTRY")} :</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${storeInfo?.country?.country_name}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <h5 className="mt-3 mb-1">
                      {t("MANAGER")} {t("DETAIL")}
                    </h5>
                    <Form.Group controlId="manager_name">
                      <Form.ControlLabel>{t("NAME")}:</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${storeInfo?.primary_admin?.name}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="manager_phone">
                      <Form.ControlLabel>{t("MOBILE")}:</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${storeInfo?.primary_admin?.mobile}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="manager_email">
                      <Form.ControlLabel>{t("EMAIL")}:</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${storeInfo?.primary_admin?.email}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <h5 className="mt-3 mb-1">
                      {t("CONTACT_PERSON")} {t("DETAIL")}
                    </h5>
                    <Form.Group controlId="contact_person1_name">
                      <Form.ControlLabel>
                        {t("CONTACT_PERSON1")} {t("NAME")}:
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${storeInfo?.contact_person1_name}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="contact_person1_phone">
                      <Form.ControlLabel>
                        {t("CONTACT_PERSON1")} {t("MOBILE")}:
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${storeInfo?.contact_person1_phone}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="contact_person1_email">
                      <Form.ControlLabel>
                        {t("CONTACT_PERSON1")} {t("EMAIL")}:
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${storeInfo?.contact_person1_email}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="contact_person2_name">
                      <Form.ControlLabel>
                        {t("CONTACT_PERSON2")} {t("NAME")}:
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${storeInfo?.contact_person2_name}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="contact_person2_phone">
                      <Form.ControlLabel>
                        {t("CONTACT_PERSON2")} {t("MOBILE")}:
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${storeInfo?.contact_person2_phone}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="contact_person2_email">
                      <Form.ControlLabel>
                        {t("CONTACT_PERSON2")} {t("EMAIL")}:
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${storeInfo?.contact_person2_email}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                  </Form>
                </Content>
              ) : null}
            </Container>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ViewStoreModal;
